export const isPrivate = process.env.VUE_APP_DOMAIN.includes(
  "gunma-suigai-risk.jp"
);
